/**
 * Represents the result of comparison and primarily used
 * by {@link Comparator} and implementing classes.
 */
export enum ComparisonResult {
    LESS_THAN = -1,
    EQUAL = 0,
    GREATER_THAN = 1
};
